import React from "react";
import { QuoteProps } from "@/types/modules/post/contentComponents";
import classNames from "classnames";
import Image from "next/image";

export const Quote: React.FC<QuoteProps> = ({ photo, name, quote, alignment }) => {
  return (
    <div
      className={classNames({
        "mb-6 flex flex-col border-b-2 border-orange pb-2": true,
        "mx-auto max-w-[240px] md:float-left md:-ml-12 md:mr-8": alignment === "left",
        "mx-auto max-w-[240px] md:float-right md:-mr-12 md:ml-8": alignment === "right",
        "mx-6 max-w-[400px] md:mx-auto": alignment !== "left" && alignment !== "right",
      })}
    >
      {photo && (
        <div>
          <Image src={photo} alt={name!} width={60} height={60} className="mb-6 h-[60px] w-[60px] rounded-full" />
        </div>
      )}
      <h2 className="tracking-wide mb-4 font-condensed text-3xl font-light uppercase dark:text-white sm:text-5xl">
        {quote}
      </h2>
      {name && <span className="font-sans text-base font-normal dark:text-white">{name}</span>}
    </div>
  );
};
